module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "TOC-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1"
    }
  }, [_vm._v("BUTTERCREAM BASICS")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter11"
    }
  }, [_vm._v("BASIC BUTTERCREAM RECIPE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter12"
    }
  }, [_vm._v("EQUIPMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter13"
    }
  }, [_vm._v("NOZZLES")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter14"
    }
  }, [_vm._v("COLOURING")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter15"
    }
  }, [_vm._v("COVERING CAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter16"
    }
  }, [_vm._v("FILLING A PIPING BAG")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PIPING ADVICE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BASIC PETAL STROKES")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLOWERS")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHITE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PINK")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAGENTA")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RED")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ORANGE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YELLOW")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GREEN")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BLUE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PURPLE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIOLET")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEAVES")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_vm._v("PROJECTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONTEMPORARY CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OPULENT CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OMBRE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RUSTIC CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-AHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VINTAGE CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Suppliers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUPPLIERS")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/About_the_Authors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHORS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 63
// module chunks = 0